import { Component } from 'react';
import { isFailed, isLoading, isSucceeded } from 'conversations-async-data/async-data/operators/statusComparators';
import AsyncData from 'conversations-async-data/async-data/AsyncData';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import H2 from 'UIComponents/elements/headings/H2';
import I18n from 'I18n';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIModal from 'UIComponents/dialog/UIModal';
import UISelect from 'UIComponents/input/UISelect';
import { fetchAdminUsers } from '../clients/fetchAdminUsers';
import { fromJS } from 'immutable';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { mapUsersToOptions } from '../../sales-users/operators/mapUsersToOptions';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import { requestFailed } from 'conversations-async-data/async-data/operators/requestFailed';
import { requestStarted } from 'conversations-async-data/async-data/operators/requestStarted';
import { requestSucceededWithOperator } from 'conversations-async-data/async-data/operators/requestSucceededWithOperator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class SendDisconnectedAccountEmailPrompt extends Component {
  constructor(props) {
    super(props);
    this.displayName = 'SendDisconnectedAccountEmailPrompt';
    this.getSelectedSalesUser = () => {
      const options = getData(this.state.asyncAdminSalesUsers);
      return options.find(salesUser => {
        return salesUser.value === this.state.selectedAdminId;
      }) || {};
    };
    this.handleSetAdminToEmail = ({
      target: {
        value
      }
    }) => {
      this.setState({
        selectedAdminId: value
      });
    };
    this.sendEmail = () => {
      this.props.sendDisconnectedAccountEmail({
        disconnectedAccountEmail: this.props.email,
        recipientUserId: this.state.selectedAdminId,
        inboxId: this.props.inboxId
      });
      this.props.trackSendEmail({
        emailToReconnect: this.props.email,
        emailSentTo: this.getSelectedSalesUser().email
      });
      this.props.onConfirm();
    };
    this.state = {
      selectedAdminId: props.selectedAdminId,
      // @ts-expect-error ts-migrate(2348) FIXME: Value of type 'new <AsyncDataValue>(t?: Partial<As... Remove this comment to see the full error message
      asyncAdminSalesUsers: AsyncData()
    };
  }
  componentDidMount() {
    this.setState(({
      asyncAdminSalesUsers
    }) => ({
      asyncAdminSalesUsers: requestStarted(asyncAdminSalesUsers)
    }));
    fetchAdminUsers().then(adminSalesUsersArray => {
      const adminSalesUsers = fromJS(adminSalesUsersArray);
      this.setState(({
        asyncAdminSalesUsers
      }) => ({
        asyncAdminSalesUsers: requestSucceededWithOperator(() => mapUsersToOptions(adminSalesUsers), asyncAdminSalesUsers)
      }));
    }).catch(error => {
      reportError({
        error,
        tags: {
          isVisibleToUser: true
        }
      });
      this.setState(({
        asyncAdminSalesUsers
      }) => ({
        asyncAdminSalesUsers: requestFailed(asyncAdminSalesUsers)
      }));
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  renderSelect() {
    const options = getData(this.state.asyncAdminSalesUsers);
    return /*#__PURE__*/_jsx(UISelect, {
      className: "m-top-4",
      defaultValue: this.state.selectedAdminId
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      options: options,
      onChange: evt => this.handleSetAdminToEmail(evt),
      placeholder: I18n.text('conversations-inbox-ui.sendDisconnectedAccountEmailPrompt.placeholder')
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(UIModal, {
      children: [/*#__PURE__*/_jsx(UIDialogHeader, {
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.sendDisconnectedAccountEmailPrompt.title"
          })
        })
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.sendDisconnectedAccountEmailPrompt.body",
          options: {
            email: this.props.email
          }
        }), isLoading(this.state.asyncAdminSalesUsers) && /*#__PURE__*/_jsx(UILoadingSpinner, {}), isSucceeded(this.state.asyncAdminSalesUsers) && this.renderSelect(), isFailed(this.state.asyncAdminSalesUsers) && /*#__PURE__*/_jsxs(UIErrorMessage, {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.fatalError.refreshThePage"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.fatalError.contactSupport"
          })]
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: this.sendEmail,
          disabled: this.state.selectedAdminId === undefined,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.sendDisconnectedAccountEmailPrompt.confirm"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "secondary",
          onClick: this.props.onReject,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.sendDisconnectedAccountEmailPrompt.cancel"
          })
        })]
      })]
    });
  }
}